export const PXLubricant = (() => {
  function init() {
    // If form exists on page, add event listeners
    if (jQuery('#lubricant').length) events()
  }

  function events() {
    // On form submit
    jQuery('#lubricant').submit(event => {
      // Prevent page from reloading
      event.preventDefault()

      /* Validation */
      // Ensure run length is a number
      let message = ''
      let runLength = Math.round(document.lubricant.runLength.value)
      if (isNaN(runLength)) {
        message += `<p class="calculator__paragraph">${lubricant.responses.run_length_must_be_number}</p>`
        document.lubricant.runLength.value = ''
      } else document.lubricant.runLength.value = runLength

      // Ensure proper run length bounds
      if (runLength <= 0)
        message += `<p class="calculator__paragraph">${lubricant.responses.run_length_must_be_positive}</p>`
      else if (runLength > 500000)
        message += `<p class="calculator__paragraph">${lubricant.responses.run_length_not_above}</p>`
      /* Ends validation */

      // If no errors
      let special = ''
      if (!message) {
        // Establish size and quantity multiplier based on units
        const units = document.lubricant.units.value
        let size = document.lubricant.size.value
        let multiplier = 0.0015
        if (units === 'metric') {
          size = Math.round(25.4 * size)
          multiplier = 0.00075
        }

        // Calculate baseline quantity
        let quantity = size * runLength * multiplier

        // Add to partial sum based on condition
        let partial = 0
        const condition = document.lubricant.condition.value
        if (condition === 'fair') partial += quantity * 0.25

        // Add to partial sum based on degree of bends
        const bends = document.lubricant.bends.value
        if (bends === 'medium') partial += quantity * 0.1
        else if (bends === 'high') partial += quantity * 0.25

        // Add to partial sum based on units and run length
        if (units === 'english' && runLength > 500) partial += quantity * 0.1
        else if (units === 'metric' && runLength > 150)
          partial += quantity * 0.1

        // Add partial sum to baseline quantity
        quantity += partial

        // Set quantity precision and liquid units based on units and quantity
        let liquidUnits = lubricant.units.liters
        if (units === 'english') {
          if (quantity < 1) {
            quantity = Math.ceil(40 * quantity) / 10
            liquidUnits = lubricant.units.quarts
          } else {
            quantity = Math.ceil(quantity * 10) / 10
            liquidUnits = lubricant.units.gallons
          }
        } else quantity = Math.ceil(quantity)

        // Display recommended quantity message
        message += `<p class="calculator__message-heading">${lubricant.responses.heading}</p>
        <p class="calculator__paragraph">${lubricant.responses.quantity}: ${quantity} ${liquidUnits}</p>`

        // Display fair/poor condition message if necessary
        if (condition === 'fair')
          message += `<p class="calculator__paragraph">${lubricant.responses.fair_condition}</p>`

        // Handle special cases
        if (
          bends !== 'low' ||
          (units === 'english' && runLength > 500) ||
          (units === 'metric' && runLength > 150)
        ) {
          // Set reason for including additional lubricant based on bends, units, and run length
          let reason = ''
          if (bends !== 'low') reason += lubricant.responses.high_bend_text
          if (
            (units === 'english' && runLength > 500) ||
            (units === 'metric' && runLength > 150)
          ) {
            if (reason) reason += ', '
            reason += lubricant.responses.long_length
          }

          // Display reason for additional lubricant message
          message += `<p class="calculator__paragraph">${lubricant.responses.additional_lubricant} ${reason}.</p>`

          // If front end pack recommended, display according messages
          if (
            (units === 'english' && size > 2) ||
            (units === 'metric' && size > 50)
          ) {
            message += `<div class="calculator__paragraph">${lubricant.responses.front_end_pack}</div>`

            special += `<p class="calculator__paragraph"><a href="${lubricant.responses.front_end_pack_link.url}">${lubricant.responses.front_end_pack_link.title}</a></p>`
          }
          // Else if prelubrication methods should be considered/recommended, display according message
          else if (
            (units === 'english' && size <= 2) ||
            (units === 'metric' && size <= 50)
          ) {
            // Set recommendation message based on bends
            let recommendation = lubricant.responses.should_be_considered
            if (bends !== 'low')
              recommendation = lubricant.responses.recommended

            // Display recommendation message
            message += `<p class="calculator__paragraph">${lubricant.responses.prelubrication_methods} ${recommendation}.</p>`

            // If fiber optic pull, display according messages
            if (
              (units === 'english' && runLength > 1500) ||
              (units === 'metric' && runLength > 500)
            ) {
              message += `<p class="calculator__paragraph">${lubricant.responses.fiber_optic}</p>`
              special += `<p class="calculator__paragraph"><a href="${lubricant.responses.fiber_lubricant.url}">${lubricant.responses.fiber_lubricant.title}</a></p>
                <p class="calculator__paragraph"><a href="${lubricant.responses.lubemaster.url}">${lubricant.responses.lubemaster.title}</a></p>
                <p class="calculator__paragraph"><a href="${lubricant.responses.fiber_installation.url}">${lubricant.responses.fiber_installation.title}</a></p>`
            }
          }
        }
      }

      // Set form messages
      jQuery('#lubricant-messages').html(message + special)
    })

    // On english button click, set units to English, clear values
    const { runLength } = document.lubricant
    jQuery('#lube-units').change(function () {
      if (jQuery(this).val() === 'english') {
        jQuery('#size').text(lubricant.units.inches)
        jQuery('#run-length').text(lubricant.units.feet)
      } else {
        jQuery('#size').text(lubricant.units.millimeters)
        jQuery('#run-length').text(lubricant.units.meters)
      }

      runLength.value = ''
    })

    // On clear button click, clear values
    jQuery('#clear-lubricant').click(ev => {
      runLength.value = ''
      jQuery('#lubricant-messages').html(
        '<p class="calculator__paragraph">No calculations done yet</p>'
      )
      jQuery('#lubricant select').each((idx, el) => {
        jQuery(el).val(jQuery(el).find('option').eq(0).val())
      })
      if (jQuery('#lube-units').val() === 'english') {
        jQuery('#size').text(lubricant.units.inches)
        jQuery('#run-length').text(lubricant.units.feet)
      } else {
        jQuery('#size').text(lubricant.units.millimeters)
        jQuery('#run-length').text(lubricant.units.meters)
      }
    })
  }

  return { init }
})()
